
// Used through the app to provide constant texts across components

// PROPERTIES
// ---- aboutScreen
// ---- ----- Mission sub-screen
export const kAboutMissionTexts = {
    intro: "Devenir le repère des collégiens en mathématiques",
    missionOne: "Le nom Ummia vient de l’étoile polaire, aussi appelée Alpha Ursae Minoris (α UMi). Comme cette étoile qui guide les voyageurs, Ummia veut aider chaque élève à s'orienter dans les mathématiques. Quel que soit son niveau, l’application doit offrir les moyens de comprendre, progresser et réussir.",
    missionTwo: "Parce que les mathématiques sont une matière cumulative, où chaque nouvelle notion s’appuie sur les précédentes, maîtriser les fondamentaux est essentiel pour progresser. Chez Ummia, c’est notre combat : permettre à chaque élève de construire des bases solides et durables, en lui donnant la possibilité de revoir les savoirs des années précédentes quand il en a besoin. Pour en savoir plus sur notre méthode, ",
    overHere: "c'est par ici",
}

// ---- ---- Method sub-screen
export const kAboutMethodTexts = {
    introOne: "Chez Ummia, tout commence avec ",
    introLink: "le programme officiel",
    introTwo: " découpé en savoir-faire. Nous en distinguons deux types :",
    one: "Les savoir-faire fondamentaux / simples, qui reposent sur une connaissance (définition, théorème ou méthode) à retenir par cœur. Ce sont les applications directes du cours.",
    two: "Les savoir-faire complexes, qui s’appuient sur un ou plusieurs savoir-faire fondamentaux.",
    three: "Le tout forme une chaîne de progression de plus en plus abstraite pour l'élève. Par exemple, en CM1 :",
    four: "Beaucoup d'élèves apprennent par cœur les connaissances du cours sans les comprendre et en classe, il arrive qu'un savoir-faire complexe soit abordé sans que la base soit acquise. Notre priorité chez Ummia, c'est donc la maîtrise absolue des fondamentaux.",
    oneT: "Dans l’onglet Cours et exercices, chaque savoir-faire fondamental est accompagné de la connaissance associée et d’un flash : un QCM rapide pour tester la compréhension et l’application du cours.",
    twoT: "Les réponses proposées ne sont jamais choisies au hasard : elles reflètent des erreurs fréquentes observées en classe, liées soit à une mauvaise compréhension du concept, soit à un manque de maitrise d’un savoir-faire antérieur.",
    threeT: "À la fin du flash, chaque proposition de réponse est expliquée pour aider l’élève à comprendre ses erreurs et progresser.",
}

// ---- ---- Team sub-screen
export const kAboutTeamTexts = {
    geoName: "Geoffroy Laboudigue",
    geoOne: "Professeur de mathématiques chevronné avec plus de 15 ans d'expérience, c’est lui qui est à l’initiative d’Ummia. Il est également formateur d’enseignants à l’Éducation Nationale et auteur de manuels scolaires aux ",
    geoTwo: "éditions Hachette",
    geoThree: ". Il tient depuis ses débuts, la chaine youtube ",
    geoFour: "Mathlab ",
    geoFive: "qui aide de nombreux élèves en France à progresser en mathématiques. À travers Ummia, il veut montrer que tous les élèves peuvent réussir.",
    margotName: "Margot Maussion",
    margot: "Responsable communication, Margot possède 10 ans d’expérience en communication et en gestion de projets, notamment orientées vidéo. Elle conçoit et réalise les contenus pour faire connaître l'application et veille à ce qu’elle devienne une référence chez les collégiens.",
    chloeName: "Chloé David",
    chloe: "Designeuse diplômée de l’école des Gobelins, Chloé possède 8 ans d’expérience dans le design graphique, le développement web et l’expérience utilisateur (UI/UX). Séduite par le concept d’Ummia, elle a à cœur de rendre l’expérience la plus fluide et la plus intuitive possible pour les enfants.",
    quentinName: "Quentin Laboudigue",
    quentin: "Ingénieur de formation et passionné de pédagogie, il exerce pendant deux années en tant que professeur de mathématiques au collège. Suite à sa reconversion en tant que développeur d'applications web et mobile, il se lance dans la production d'Ummia. Il est persuadé qu'un outil numérique interactif est la clé pour que tous les élèves réussissent en mathématiques au collège.",
}

// ---- ---- Contact sub-screen
export const kAboutContactTexts = {
    message: "Nous ne sommes actuellement pas assez nombreux pour répondre à des questions concernant le contenu de l'application mais nous restons disponibles pour des questions légales à l'adresse suivante\u00A0: ",
    mailAddress: "contact@ummia.fr"
}

// ---- Errors
export const kErrorTexts = {
    // PreviewQuestion screen
    fetchQuestionTitle: "La question demandée n'est pas trouvable",
    fetchQuestionSubtitle: "Veuillez contacter un administrateur",
    // Neutral
    neutralErrorStatementText: "Une erreur serveur est survenue",
    neutralErrorReassuranceText: "Nous faisons notre possible pour résoudre le problème au plus vite"
}

// ---- Voids
export const kVoidTexts = {
    levelAsList: "Sélectionne un chapitre pour afficher les savoir-faire associés"
}

// ---- courses
export const kCoursesTexts = {
    example: "Exemple",
    launchExerciser: "Exercice",
    launchFlashShort: "Flash",
    launchFlashLong: "Lancer un Flash",
}

export const kExerciserTexts = {
    // ---- ---- score appreciation
    appreciationErrorScore: "Nous avons rencontré une erreur avec ton score. Continue à pratiquer pour progresser",
    averageScore: "Tu as obtenu la moyenne. Essaye de comprendre tes erreurs et la connaissance associée pour vraiment maitriser ce savoir-faire",
    goodScore: "C'est bien, continue comme ça. Essaye de relancer un exercice pour t'assurer que tu maitrises ce savoir-faire",
    perfectScore: "Félicitations pour ce score parfait. Tu sembles prêt-e pour l'évaluation",
    veryGoodScore: "C'est très bien, essaye de recommencer pour viser le score parfait",
    underScore: "C'est en dessous de la moyenne. Essaye de refaire un Flash pour bien comprendre la connaissance associée. Courage",
    nullScore: "Garde confiance en toi. En refaisant un Flash, tu auras plus d'explication pour comprendre la connaissance",
}

// ---- courses > flash
export const kFlashTexts = {
    back: "Retour",
    backToHome: "Retour à l'accueil",
    dontKnowTitle: "Tu ne connais pas la réponse ?",
    dontKnowSubtitle: "Il est possible que tu n'aies pas vu la notion en classe, cela nous aidera à mieux répertorier les questions",
    launchTheFlash: "Lancer le flash",
    leaveCurrentFlashTitle: "Es-tu certain.e de vouloir quitter la série en cours ?",
    leaveCurrentFlashSubtitle: "Tu perdras toute ta progression et tu ne pourras pas consulter la correction des questions auxquelles tu as déjà répondu",
    leaveFlash: "Quitter le flash",
    noGradeSelected: "Commence par sélectionner une classe pour trouver le savoir-faire que tu souhaites réviser",
    // ---- ---- score appreciation
    appreciationErrorScore: "Nous avons rencontré une erreur avec ton score. Continue à pratiquer pour progresser",
    averageScore: "Tu as obtenu la moyenne. Essaye de comprendre tes erreurs et la connaissance associée pour vraiment maitriser ce savoir-faire",
    goodScore: "C'est bien, continue comme ça. Essaye de relancer un flash pour t'assurer que tu maitrises ce savoir-faire",
    perfectScore: "Félicitations pour ce score parfait. Tu sembles prêt-e pour l'évaluation",
    veryGoodScore: "C'est très bien, essaye de recommencer pour viser le score parfait",
    underScore: "C'est en dessous de la moyenne. En allant dans la correction, tu as toutes les armes pour comprendre tes erreurs et progresser. Courage",
    nullScore: "Garde confiance en toi. En allant dans la correction, tu as toutes les armes pour comprendre la connaissance et comment l'appliquer",
    // ---- ----  parameterStepScreen
    parameterScreenTitle: "Ça va bientôt commencer !",
    parameterScreenSubtitle: "Nous te conseillons de préparer un crayon et un brouillon",
    // ---- ---- resultsStepScreen
    resultsDesktopTopTitle: "Félicitations, tu as fini la série !",
    resultsDesktopTopSubtitle: "Tu peux maintenant consulter la correction par question",
    resultsTabletTopTitle: "Tu as fini la série !",
    resultsTabletTopSubtitle: "Tu peux maintenant consulter la correction",
}

// ---- Exercisers
export const kExercisersTexts = {
    leaveExerciser: "Quitter l'exercice",
    // ---- results
    resultsDesktopTopTitle: "Félicitations, tu as fini la série !",
    resultsDesktopTopSubtitle: "Tu peux maintenant consulter la correction par question",
    resultsTabletTopTitle: "Félicitations, tu as fini la série !",
    resultsTabletTopSubtitle: "Tu peux maintenant consulter la correction",
}

// ---- Games
export const kGamesTexts = {
    leave: "Quitter le jeu",
    myAdvices: "Mes conseils\u00A0:",
    myNotes: "Mes remarques\u00A0:",
    plusMinus: "+/-"
}

// ---- glossaryScreen
export const kGlossaryTexts = {
    context: "Contexte",
    contextTab: "context",
    definition: "Definition",
    definitionTab: "definition",
    flexSearch: "Recherche flexible",
    flexSearchTooltip: "Affiche les termes dont le mot ou la définition contient le texte recherché, même partiellement.",
    strictSearch: "Recherche stricte",
    strictSearchTooltip: "Affiche uniquement les termes dont le mot commence exactement par ta recherche.",
}

// ---- homeScreen
export const kHomeTexts = {
    callToActionLabel: "C'est parti !",
    downloadTitle: "Télécharge l'application sur mobile et emmène Ummia partout avec toi",
    downloadContent: "Nous voulons qu'Ummia puisse t'accompagner tout au long du collège dans chaque moment où tu en aurais besoin. Pour cela, l’application est accessible sur Android et iOS.",
    punchline: "Progresse en mathématiques en maitrisant les fondamentaux\ndu CM1 à la 3<sup>ème</sup>",
    subPunchline: "Quelque soit ton niveau, Ummia te guide vers la maîtrise de chaque savoir-faire. Nos contenus te permettent d'apprendre en pratiquant, simplement et pas à pas.",
    missionTitle: "Le projet",
    missionContent: "Chez Ummia, notre mission est que chaque élève de collège réussisse scolairement tout en prenant goût aux mathématiques. Pour cela, nous sommes convaincus que la clé réside dans la maitrise des savoir-faire fondamentaux du programme.",
    navAbout: "À propos",
    navCourses: "Cours et exercices",
    navGames: "Jeux",
    navGlossary: "Glossaire",
    navLegals: "Mentions légales",
    navPrivacy: "Confidentialité",
    navThemes: "Le programme",
}

// ---- knowledgesScreen
export const kKnowledgesTexts = {
    noGradeSelected: 'Commence par sélectionner le niveau dont tu veux afficher les connaissances',
    definitionType: "Définition",
    conventionType: "Convention",
    formulaType: "Formule",
    methodType: "Méthode",
    theoremType: "Théorème",
    propertyType: "Propriété",
    unknownType: "Type inconnu"
}

// ---- themesScreen
export const kThemesTexts = {
    introText: "Le programme scolaire officiel de mathématiques est le fondement du contenu de l'application. Il est actuellement découpé en 5 grands thèmes qui sont abordés à différents moments de ta scolarité. Ci-dessous, tu trouveras le détail de chaque grand thème."
}

// ---- supportProjectScreen
export const kSupportProjectScreenTexts = {
    introOne: "Pour celles et ceux qui souhaitent soutenir le projet, une ",
    introTwo: "cagnotte en ligne",
    introThree: " est maintenant disponible. Ummia est née avec une idée forte : proposer un environnement d’apprentissage clair, calme et sans publicité, dédié à l'enfant. Un lieu qui permet à chaque élève de collège de rester concentré sur l’essentiel\u00A0: apprendre, comprendre, et progresser à son rythme, toujours avec le plaisir d’y revenir quand il en a besoin.",
    bodyOne: "Votre soutien nous aidera à\u00A0:",
    bodyTwo: "Couvrir une partie des frais d'hébergement croissants, car Ummia ne dispose pour l’instant d’aucune source de revenus.",
    bodyThree: "Développer de nouvelles fonctionnalités, comme un espace utilisateur et un mode exam.",
    bodyFour: "Finaliser au plus vite la rédaction des savoir-faire (350) et le contenu associé\u00A0: questions flash, exerciseurs, et vidéos pédagogiques.",
    conclusion: "Chaque participation compte. Elle aide à faire grandir Ummia tout en gardant son indépendance et sa promesse : celle de donner aux collégiens les clés de l'apprentissage en mathématiques."
}

// ---- SYSTEM
export const kSystemTexts = {
    back: "Retour",
    cancel: "Annuler",
    contactMailAddress: "contact@ummia.fr",
    erase: "Effacer",
    explanation: "Explication",
    falseSelectedAnswer: "Tu as fait une erreur",
    falseUnselectedAnswer: "C'est une erreur",
    goodSelectedAnswer: "Tu as trouvé la bonne réponse",
    goodUnselectedAnswer: "Voici la bonne réponse",
    home: "Retour à l'accueil",
    leave: "Quitter",
    loremIpsumExtraShort: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    loremIpsumShort: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    loremIpsumLong: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    understood: "J'ai compris",
    skills: "Savoir-faire",
    trap: "À retenir",
    themes: "Chapitres",
    retry: "Réesayer",
    validate: "Valider",
}

export const kSystemDrawerNavText = {
    // ---- main
    courses: "Cours et exercices",
    brevet: "Brevet",
    glossary: "Glossaire",
    games: "Jeux",
    // ---- side
    themes: "Le programme",
    about: "À propos",
}

